import React from 'react';
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import ReactDOM from 'react-dom'
import $ from 'jquery'
import 'datatables.net'
import 'datatables.net-responsive'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import { authHeader } from '../../_helpers'
import { Notif , Loading } from '../../_components'
import axios from 'axios';

const { REACT_APP_API_URL :  API_URL} =process.env

class BOMRedux extends React.Component {
  constructor({props}) {
      super(props);
      this.state = {
        loading : null,
      
    }
  }

  componentDidMount(){
       $('#items').DataTable( {
        ordering: true,
        searching: true,
        processing: true,
        serverSide:true,
        bFilter: true,
        bInfo:true,
        bLengthChange: true,
        bPaginate:true,
        ordering: true,
        scrollCollapse: true,
        scrollY: true,
        scrollX: true,
        "ajax": {
          "url": `${API_URL}/api/bom_modal${this.props.modal.query ? this.props.modal.query : ''}`,
          "dataSrc" : 'data',
          "beforeSend": function (xhr) {
              xhr.setRequestHeader('Authorization',authHeader())
            }
          },
        columnDefs : [
            {
                'targets': [0],
                createdCell : (td, cellData, rowData, row, col) => {
                    ReactDOM.render(<React.Fragment>
                    <button 
                      className="btn btn-primary btn-sm" 
                      onClick={() => {
                        this.Pilih(
                            rowData[0],
                            `${rowData[1]} - ${rowData[2]}`, 
                            rowData[4],
                            rowData[5],
                            rowData[6],
                            rowData[7])
                      }}>Pilih</button>
                      </React.Fragment>,td);
                }
            },
            {
                'targets': [5],
                createdCell : (td, cellData, rowData, row, col) => {
                   ReactDOM.render(<React.Fragment><b>{new Intl.NumberFormat( 'ID' ).format(rowData[5])}</b></React.Fragment>,td);
                }
            },
            
        ]
     } );
    }

   Pilih(id,name, name_item, total, id_item, qty){
     const {onChange}= this.props.modal
     const options = {
        headers : {
           Authorization: authHeader(),
        }
      }

     this.setState({loading: true})
     onChange && axios.all([
        axios.get(`${API_URL}/api/get_bom_detail?id_header=${id}`, options),
     ])
     .then(axios.spread((bom) => {
        this.setState({loading: false})
        onChange(id,name, name_item, total, id_item, qty, bom.data)
        this.onClose()
     }))
     .catch(({response : { request : { response : error }} }) => {
        this.setState({loading: false})
        Notif('Opssss', error,'toast-bottom-right','4')
      });
     
   } 

   onClose = () =>{
    this.props.Modal(null)
   }

  render() {

    const backdropStyle = {
      position: 'fixed', /* Stay in place */
      zIndex: 1, /* Sit on top */
      left: 0,
      top: 0,
      width: '100%', /* Full width */
      height: '100%', /* Full height */
      overflow: 'auto', /* Enable scroll if needed */
      backgroundColor: 'rgb(0,0,0)', /* Fallback color */
      backgroundColor: 'rgba(0,0,0,0.4)' /* Black w/ opacity */
    };

   
    return (
      <div className="modal-backdrop" style={backdropStyle}>
      <div className='animated fadeInRight'>
        <Modal.Dialog 
            size="lg"
            aria-labelledby="example-modal-sizes-title-lg"
            style={{top : 25}}
         >
         <Modal.Header>
        <Modal.Title>Cari B.O.M</Modal.Title>
        </Modal.Header>

        {this.state.loading ? <div><Loading/></div> :
        <Modal.Body>
                <table className="table table-striped" style={{whiteSpace: 'nowrap', width: '100%'}} id="items">
                  <thead>
                      <tr>
                          <th></th>
                          <th>Kode</th>
                          <th>Nama</th>
                          <th>Note</th>
                          <th>Item</th>
                          <th>Total</th>
                      </tr> 
                  </thead>
                </table>
        </Modal.Body>
        }
        <Modal.Footer>
            <Button variant="secondary" onClick={this.onClose}>Close</Button>
        </Modal.Footer>
        </Modal.Dialog>
      </div>
      </div>
    );
  }
}


export  { BOMRedux };




